import { types as t } from 'mobx-state-tree';


const Field = t.model("Field", {
	DataTypeId: t.string,
	Name: t.string,
    SortOrder: t.number,
    DisplayName: t.string,      // Flatten, and only load current language
    DisplayOnWebSite: t.boolean,
    Facet: t.boolean

	
}).views(self => ({

})).actions(self => ({

}));


export default Field;